const API_BASE = 'https://panel.miladcoolingindustry.com/api';

async function request(path, options = {}) {
  const token = localStorage.getItem("token");

  if (!token) {
    throw new Error("No token");
  }

  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`,
    ...(options.headers || {})
  };

  const opts = {
    method: options.method || "GET",
    credentials: "include",
    headers,
    body: options.body || null
  };

  const res = await fetch(`${API_BASE}/${path}`, opts);
  const data = await res.json().catch(() => ({}));

  if (res.status === 401) {
    localStorage.removeItem("token");
    window.location.href = "/login";
    return;
  }

  if (!res.ok) {
    throw new Error(data.message || `Request failed (${res.status})`);
  }

  return data;
}

export async function login(username, password) {
  const res = await fetch(`${API_BASE}/login.php`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  });

  const data = await res.json();

  if (data.success && data.token) {
    localStorage.setItem("token", data.token);
  }

  return data;
}

export async function getRegistrations() {
  return request("get_registrations.php");
}

export async function deleteRegistration(id) {
  return request("delete_registration.php", {
    method: "POST",
    body: JSON.stringify({ id })
  });
}

export async function activateWarranty(payload) {
  return request("activate_warranty.php", {
    method: "POST",
    body: JSON.stringify(payload)
  });
}

export async function getCustomers() {
  return request("get_customers.php");
}

export async function updateCustomer(data) {
  return request("update_customer.php", {
    method: "POST",
    body: JSON.stringify(data)
  });
}

export async function getWarrantyRequests() {
  return request("get_warranty_requests.php");
}
